import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/ui/Layout';
import { HomePage } from './pages/HomePage';
import { GeneratePage } from './pages/GeneratePage';
import { PreviewPage } from './pages/PreviewPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { SuccessPage } from './pages/SuccessPage';
import { DashboardPage } from './pages/DashboardPage';
import { AuthVerifyPage } from './pages/AuthVerifyPage';
import { SiteDetailPage } from './pages/SiteDetailPage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/generate" element={<GeneratePage />} />
        <Route path="/preview/:sessionId" element={<PreviewPage />} />
        <Route path="/checkout/:sessionId" element={<CheckoutPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dashboard/sites/:siteId" element={<SiteDetailPage />} />
        <Route path="/auth/verify" element={<AuthVerifyPage />} />
      </Route>
    </Routes>
  );
}
